import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroClasseJudicial extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    get label() {
        return 'Classe judicial (fase)';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        return registro.classeProcesso.split('-')[0];
    }
}
